import { useEffect, useState } from "react";
import { IWorkitem } from "models/projects/Workitem/Workitem";
import useCentralApi from "hooks/shared/useCentralApi";
import { useCurrentUser } from "hooks/shared";

type GetProjectWorkItemsResult = {
    projectWorkItems: IWorkitem[] | null,
    totalItems: number
};
type UseProjectWorkItemsResult = [
    GetProjectWorkItemsResult | null,
    boolean,
    string | null
];

const useProjectWorkItems: (projectId: string | undefined, workItemStatus: string) => UseProjectWorkItemsResult = (projectId: string | undefined, workItemStatus: string) => {
    const [ result, setResult ] = useState<GetProjectWorkItemsResult | null>(null);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);
    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        const controller = new AbortController();
        if (projectId && projectId != '0' && projectId != '') {
            (async () => {
                setLoading(true);
                setResult(null);
                try {

                    const url = `/api/v3/projects/${projectId}/workitems/${workItemStatus}/all`

                    const resp = await fetcher(url, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json() as GetProjectWorkItemsResult;
                    setResult(data);
                } catch (err) {

                } finally {
                    setLoading(false);
                }
            })(); 
        }
        return () => controller.abort();
    }, [ projectId, workItemStatus ]);

    return [
        result,
        loading,
        error
    ];
};

export default useProjectWorkItems;